import useFetch from 'use-http';
import { useSelector } from 'react-redux';

export default function useFirstPayment() {
  const store = useSelector(state => ({
    integrationType: state.technical?.initialize?.integrationType,
    token: state.technical?.initialize?.token,
  }));

  let endpoint = 'https://api.katapult.com/v1';

  if (store.integrationType === 'storis') {
    if (globalThis.location.host === 'qa02-katapult-react-sdk.katapult.com') {
      endpoint = 'https://api.qa.katapult.com/v1';
    } else if (globalThis.location.host === 'sandbox-sdk.katapult.com') {
      endpoint = 'https://api.sandbox.katapult.com/v1';
    } else {
      endpoint = 'https://api.katapult.com/v1';
    }
  }
  const { post, loading, error, response } = useFetch(endpoint, {
    cachePolicy: 'no-cache',
    headers: {
      Authorization: `Bearer ${store.token}`,
    },
  });

  // First Payment
  // https://docs.katapult.com/reference#post_-uid-first-payment
  const paymentRequest = async (uid, deviceData, payload) => {
    return post(`/${uid}/first_payment/`, {
      device_data: deviceData,
      payment_details: payload,
    });
  };

  return {
    request: {
      paymentRequest,
    },
    loading,
    response,
    error,
  };
}
